import { Builder } from '@builder.io/react';

import Quote from './index';
import { customersQuotes } from './quotes';

Builder.registerComponent(Quote, {
  name: 'Quote',
  inputs: [
    {
      name: 'quotes',
      type: 'list',
      subFields: [
        {
          name: 'quote',
          type: 'string',
          defaultValue: 'flexport',
          enum: Object.keys(customersQuotes)
        }
      ],
      defaultValue: []
    },
    {
      name: 'image',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string'
    },
    {
      name: 'gradientText',
      type: 'boolean'
    }
  ]
});
